import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SelectedOdbDetailsInfo } from '../my-bill/models/pii.model';
import {
  ODB_DETAILS_SESSION_DATA_KEY,
  UtilsService,
} from '../my-bill/services/utils.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsContextResolverService {
  constructor(private utilsService: UtilsService) {}

  resolve(route: ActivatedRouteSnapshot): string {
    const documentReference = route.paramMap.get('documentId');

    if (documentReference) {
      route.data.analytics.context = documentReference;
    } else {
      route.data.analytics.context =
        this.utilsService.getInfoFromSessionStorage<SelectedOdbDetailsInfo>(
          ODB_DETAILS_SESSION_DATA_KEY
        )?.billDocument?.reference ?? '';
    }
    return route.data.analytics.context;
  }
}
